import React from "react";
import { Route, Routes as Switch } from "react-router-dom";
import { Path } from "@src/common/consts/Path";
import { observer } from "mobx-react-lite";
import { Layout } from "@src/common/components/Layout";
import { useAuthorized } from "@client/hooks/useAuthorized";
import { HomePage } from "@client/pages/Home/Home";
import { AccessDeniedPage } from "@client/pages/AcessDeniedPage";
import { CreateCampaignPage } from "@client/pages/CreateCampaign/CreateCampaign";
import { EditCampaignPage } from "@client/pages/EditCampaign/EditCampaign";
import { ShowCampaignPage } from "@client/pages/ShowCampaign/ShowCampaign";
import { useStores } from "@client/store";

export const Routes = observer((): JSX.Element => {
  const {
    client: {
      authStore: { isFetching },
    },
  } = useStores();

  useAuthorized();

  // костыль, сначала ждем ручку /auth, после этого уже доступны страницы
  if (isFetching) {
    return null;
  }

  return (
    <Switch>
      <Route path="/" element={<Layout />}>
        <Route
          index
          key={Path.TO_HOME}
          path={Path.TO_HOME}
          element={<HomePage />}
        />
        <Route
          key={Path.TO_ACTIVE}
          path={Path.TO_ACTIVE}
          element={<HomePage />}
        />
        <Route
          key={Path.TO_PLANNED}
          path={Path.TO_PLANNED}
          element={<HomePage />}
        />
        <Route
          key={Path.TO_FINISHED}
          path={Path.TO_FINISHED}
          element={<HomePage />}
        />
        <Route
          key={Path.TO_MODERATED}
          path={Path.TO_MODERATED}
          element={<HomePage />}
        />
        <Route
          key={Path.TO_ACCESS_DENIED}
          path={Path.TO_ACCESS_DENIED}
          element={<AccessDeniedPage />}
        />
        <Route
          key={Path.TO_CREATE}
          path={Path.TO_CREATE}
          element={<CreateCampaignPage />}
        />
        <Route
          key={Path.TO_EDIT_CAMPAIGN}
          path={Path.TO_EDIT_CAMPAIGN}
          element={<EditCampaignPage />}
        />
        <Route
          key={Path.TO_CAMPAIGN}
          path={Path.TO_CAMPAIGN}
          element={<ShowCampaignPage />}
        />
      </Route>
    </Switch>
  );
});
